import Cookies from 'universal-cookie';

/**
 * @function setItem stores data in Storage with expire date
 * @param key stored data key
 * @param value value to store
 * @param expire expire data can be undefined to not set expire data
 */
export const setItem = (key, value, expire) => {
  if (expire) {
    const now = Date.now();
    const expiresIn = now + expire * 1000;
    localStorage.setItem(`${key}_expiresIn`, expiresIn.toString());
  }
  localStorage.setItem(key, value);
};

/**
 * @function getItem checks if data has expire data if true and has passed that time will remove all data otherwise return data
 * @param key sotred data key
 */
export const getItem = (key) => {
  const expiresIn = localStorage.getItem(`${key}_expiresIn`);
  if (expiresIn) {
    const now = Date.now();

    if (Number(expiresIn) > now) {
      // expired
      localStorage.removeItem(key);
      localStorage.removeItem(`${key}_expiresIn`);

      return;
    } else {
      return localStorage.getItem(key);
    }
  } else {
    return localStorage.getItem(key);
  }
};

export const setOTPTokenCookie = (value) => {
  const cookie = new Cookies();
  return cookie.set('otptoken', value, { path: '/', maxAge: 1000 * 60 * 3, sameSite: true });
};

export const getOTPTokenCookie= () =>{
  const cookies = new Cookies();
  return cookies.get('otptoken')
};

export const removeOTPTokenCookie = () => {
  const cookies = new Cookies();
  return cookies.remove('otptoken', { path: '/' })
};

export const setRefreshTokenCookie = (value) => {
  const cookie = new Cookies();
  return cookie.set('refreshtoken', value, { path: '/', maxAge: 1000 * 60 * 60 * 24 * 7, sameSite: true }); // 7 days
};

export const getRefreshTokenCookie= () =>{
  const cookies = new Cookies();
  return cookies.get('refreshtoken')
};

export const removeRefreshTokenCookie = () => {
  const cookies = new Cookies();
  return cookies.remove('refreshtoken', { path: '/' })
};

export const setAccessTokenCookie = (value) => {
  const cookie = new Cookies();
  return cookie.set('accesstoken', value, { path: '/', maxAge: 3 * 60 * 60, sameSite: true }); //1 hour
};

export const getAccessTokenCookie= () =>{
  const cookies = new Cookies();
  return cookies.get('accesstoken')
};

export const removeAccessTokenCookie = () => {
  const cookies = new Cookies();
  return cookies.remove('accesstoken', { path: '/' })
};

export const openIndexDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open('AudioDB', 1);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains('layers')) {
        db.createObjectStore('layers', { keyPath: 'id' });
      }
    };

    request.onsuccess = (event) => {
      resolve(event.target.result);
    };

    request.onerror = (event) => {
      console.error('Error opening database:', event.target.error);
      reject(event.target.error);
    };
  });
};

export const deleteDataFromIndexDB = async (key) => {
  const db = await openIndexDB();
  const transaction = db.transaction(key, 'readwrite');
  const store = transaction.objectStore(key);

  const request = store.clear();

  request.onsuccess = () => {
    return true
    // console.log('data object store cleared');
  };

  request.onerror = (event) => {
    console.error('Error clearing data object store:', event.target.error);
  };
};

export const setDataToIndexDB = async (key, value) => {
  try {
    const db = await openIndexDB();
    const transaction = db.transaction([key], 'readwrite');
    const store = transaction.objectStore(key);
    await new Promise((resolve, reject) => {
      const clearRequest = store.clear();
      clearRequest.onsuccess = () => {
        resolve();
      };
      clearRequest.onerror = (event) => {
        reject(event.target.error);
      };
    });

    value.forEach((item, index) => {
      if (item) {
        store.put({ ...item, id: index });
      } else {
        store.delete(index);
      }
    });

    transaction.oncomplete = () => {};

    transaction.onerror = (event) => {
      console.error('Transaction error:', event.target.error);
    };
  } catch (error) {
    console.error('Error accessing indexDB:', error);
  }
};

export const getDataFromIndexDB = async (key) => {
  try {
    const db = await openIndexDB();
    const transaction = db.transaction([key], 'readonly');
    const store = transaction.objectStore(key);
    const allData = [];

    return new Promise((resolve, reject) => {
      const request = store.openCursor();
      request.onsuccess = (event) => {
        const cursor = event.target.result;
        if (cursor) {
          allData.push({ key: cursor.key, value: cursor.value });
          cursor.continue();
        } else {
          resolve(allData);
        }
      };

      request.onerror = (event) => {
        console.error('Error fetching data from indexDb:', event.target.error);
        reject(event.target.error);
      };
    });
  } catch (error) {
    console.error('Error accessing indexDB:', error);
  }
};


